import { Injectable } from '@angular/core';
import {BackendService} from "./backend.service";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {ResponseDto} from "../dto/response.dto";

@Injectable({
  providedIn: 'root'
})
export class TagsService {

    private urlPrefix = '/api/tag';

    constructor(private backend: BackendService) {}

    getTagsList(propertyId: any): Observable<any> {
        const url = `${this.urlPrefix}/to-add/property/${propertyId}`;
        return this.backend.get(url).pipe(
            map((response: ResponseDto) => response.response)
        );
    }
    getTagsListProperty(propertyId: any): Observable<any> {
        const url = `${this.urlPrefix}/added/property/${propertyId}`;
        return this.backend.get(url).pipe(
            map((response: ResponseDto) => response.response)
        );
    }
    saveTagsToProperty(propertyId: any, tagIds: number[]): Observable<any> {
        const url = `${this.urlPrefix}/property/${propertyId}`;
        return this.backend.post(url, tagIds).pipe(
            map((response: ResponseDto) => response.response)
        );
    }
    updateTagsToProperty(propertyId: any, tagIds: number[]): Observable<any> {
        const url = `${this.urlPrefix}/property/${propertyId}`;
        return this.backend.put(url, tagIds).pipe(
            map((response: ResponseDto) => response.response)
        );
    }
}
